import { isPremiumActive } from "./membership";

export function isMarriageSettledProfile(profile) {
  const maritalStatus = String(profile?.maritalStatus || "").trim().toLowerCase();
  const profileStatus = String(profile?.profileStatus || "").trim().toLowerCase();

  const settledMaritalStatuses = new Set([
    "marriage settled",
    "married",
    "settled",
  ]);

  const settledProfileStatuses = new Set([
    "marriage settled",
    "married",
    "settled",
  ]);

  return settledMaritalStatuses.has(maritalStatus) || settledProfileStatuses.has(profileStatus);
}

export function isBlockedOrSuspendedProfile(profile) {
  const status = String(profile?.status || "active").trim().toLowerCase();
  return status === "blocked" || status === "suspended" || Boolean(profile?.banned);
}

export function isHiddenProfile(profile) {
  return Boolean(profile?.adminHidden) || profile?.profileVisibility === "hidden";
}

export function isPremiumOnlyProfile(profile) {
  return profile?.profileVisibility === "premium";
}

function canViewerAccessPremiumOnlyProfile(viewerProfileOrPremium) {
  if (typeof viewerProfileOrPremium === "boolean") {
    return viewerProfileOrPremium;
  }
  return isPremiumActive(viewerProfileOrPremium);
}

export function canDisplayProfile(profile, viewerProfileOrPremium = null) {
  if (!profile) return false;
  if (isBlockedOrSuspendedProfile(profile)) return false;
  if (isHiddenProfile(profile)) return false;
  if (isMarriageSettledProfile(profile)) return false;
  if (isPremiumOnlyProfile(profile) && !canViewerAccessPremiumOnlyProfile(viewerProfileOrPremium)) return false;
  return true;
}

export function filterVisibleProfiles(profiles, blockedIds = [], viewerProfileOrPremium = null) {
  const blockedSet = new Set(blockedIds || []);
  return (profiles || []).filter((profile) => canDisplayProfile(profile, viewerProfileOrPremium) && !blockedSet.has(profile.id));
}
